var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStakeLp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71302 6.33812C5.71302 7.02579 6.27048 7.58325 6.95815 7.58325L13.4671 7.58325L13.4671 14.0922C13.4671 14.7799 14.0246 15.3373 14.7122 15.3373C15.3999 15.3373 15.9574 14.7799 15.9574 14.0922L15.9574 6.33812C15.9574 5.65045 15.3999 5.09299 14.7122 5.09299L6.95815 5.09299C6.27048 5.09299 5.71302 5.65045 5.71302 6.33812Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.58654 19.3259C2.11112 19.8505 2.86607 19.946 3.27277 19.5393L14.6224 8.1897C15.0291 7.783 14.9336 7.02805 14.409 6.50347C13.8844 5.9789 13.1295 5.88334 12.7228 6.29005L1.37312 17.6397C0.966416 18.0464 1.06197 18.8013 1.58654 19.3259Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakeLp);
export default __webpack_public_path__ + "static/media/stakeLp.10e8c1c67be94e4262bcb5b28ea2d1bb.svg";
export { ForwardRef as ReactComponent };